import React, { Component } from 'react'
import ReactPlayer from 'react-player'

export default class ImageVideo extends Component {
    render() {
        return (
            <div style={{ flex: 1, display: 'flex', backgroundColor: 'black', flexDirection: 'column' }}>
                <div style={{ padding: '20px', marginLeft: '10px' }}>
                    <span style={{ color: 'white', fontSize: '20px', textDecoration: 'underline' }}>Imagefilm</span>
                </div>
                <div style={{ flex: 1, padding: '0px 30px 20px 30px' }}>
                    <ReactPlayer width="100%" height="100%" url="https://www.youtube.com/watch?v=ysz5S6PUM-U" />
                </div>
            </div>
        )
    }
}
